const officersSelector = (state) => state.officer.officers

const companyOfficersSelector = (state) => state.officer.companyOfficers

export { officersSelector, companyOfficersSelector }
